import { User } from "./user.model";

export class UserCookie {
    public guid: string;
    public us_cookie: string;
    public validateApcAccess: boolean;
    public user: User;
}



// WEBPACK FOOTER //
// ./src/models/user-cookie.model.ts